import { render, staticRenderFns } from "./vsAvatar.vue?vue&type=template&id=0d003615&lang=html"
import script from "./vsAvatar.vue?vue&type=script&lang=js"
export * from "./vsAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports